import React, { useState } from 'react';
import { Table, Card, Button } from 'react-bootstrap';
import FormModal from '../../../Utils/FormModal';

// Icon
import Icon from '@mdi/react';
import { mdiSquareEditOutline, mdiTrashCanOutline } from '@mdi/js';

import ViewOptionsTableData from "./view-options-table-data.json";
import FormInputs from '../../../Utils/FormInputs';

export default function AccountTabData() {
    const [viewOptionsData] = useState(ViewOptionsTableData);

    // Edit Account modal
    const [acOptionEditModalShow, setAcOptionEditModalShow] = useState(false);
    const handleEdit = () => setAcOptionEditModalShow(true);
    const handleAcOptionEditModalClose = () => setAcOptionEditModalShow(false);

    const [accountInfoData, setAccountInfoData] = useState({
        optionsName: '',
        optionsValue: '',
        new_options_name: '',
        new_options_value: '',
    });

    const handleAcOptionEditInputChange = (index, field, value) => {
        setAccountInfoData({ ...accountInfoData, [field]: value });
    };
    const handleAcOptionEditSubmit = (e) => {
        e.preventDefault();
        setAcOptionEditModalShow(false);
    };
    const acOptionEditRows = [
        {
            columns: [
                { size: { lg: 6 }, label: 'Options Name', type: 'text', name: 'optionsName', id: 'optionsName', placeholder: 'Enter account name...', value: accountInfoData.optionsName, errormsg: '', },
                { size: { lg: 6 }, label: 'Value', type: 'text', name: 'optionsValue', id: 'optionsValue', placeholder: 'Enter value...', value: accountInfoData.optionsValue, errormsg: '', },
            ]
        },
    ];
    const acOptionEditButtons = [
        { variant: "primary", text: "Update", onClick: handleAcOptionEditSubmit },
        { variant: "secondary", text: "Cancel", onClick: handleAcOptionEditModalClose },
    ]

    // Account New Options
    const handleAcNewOptionInputChange = (index, field, value) => {
        setAccountInfoData({ ...accountInfoData, [field]: value });
    };
    const handleAcNewOptionSubmit = (e) => {
        e.preventDefault();
    };
    const acNewOptionRows = [
        {
            columns: [
                { size: { lg: 6 }, label: 'Options Name', type: 'text', placeholder: 'Enter Options Name...', name: 'new_options_name', id: 'newOptionsName', value: accountInfoData.new_options_name, errormsg: '', },
                { size: { lg: 6 }, label: 'Value', type: 'text', placeholder: 'Enter value...', name: 'new_options_value', id: 'newOptionsValue', value: accountInfoData.new_options_value, errormsg: '', },
            ]
        },
    ];
    const acNewOptionButtons = [
        { variant: "primary", text: "Add", onClick: handleAcNewOptionSubmit },
        { variant: "secondary", text: "Cancel" },
    ];

    return (
        <>
            <div className="tab-content custom-top-nav-tab" id="pills-tabContent">
                <div className="tab-pane fade show active" id="pills-view-options" role="tabpanel" aria-labelledby="pills-view-options-tab" tabIndex="0">
                    <Card className='right-content-details'>
                        <Card.Body>
                            <div className='d-flex justify-content-between align-items-center mb-3'>
                                <Card.Title className='mb-0'>View Options</Card.Title>
                                <div className='d-flex'>
                                    <div className="btn-list">
                                        <Button variant="soft-info p-0" onClick={handleEdit}>
                                            <div className='avatar avatar-sm'>
                                                <Icon path={mdiSquareEditOutline} className='avatar-icon' />
                                            </div>
                                        </Button>{' '}
                                        <Button variant="soft-danger p-0">
                                            <div className='avatar avatar-sm'>
                                                <Icon path={mdiTrashCanOutline} className='avatar-icon' />
                                            </div>
                                        </Button>{' '}
                                    </div>
                                </div>
                            </div>
                            <Table responsive className='table-lg border table-nowrap mb-0'>
                                <tbody>
                                    {viewOptionsData.map((data, i) =>
                                        <tr key={i}>
                                            <th>{data.accountheading}</th>
                                            <td>{data.accountsubtext}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </div>
                <div className="tab-pane fade" id="pills-new-options" role="tabpanel" aria-labelledby="pills-new-options-tab" tabIndex="0">
                    <Card className='right-content-details'>
                        <Card.Body>
                            <Card.Title>New Options</Card.Title>
                            <FormInputs Buttons={acNewOptionButtons} rows={acNewOptionRows} handleInputChange={handleAcNewOptionInputChange} handleSubmit={handleAcNewOptionSubmit} />
                        </Card.Body>
                    </Card>
                </div>
                <div className="tab-pane fade" id="pills-add-default-options" role="tabpanel" aria-labelledby="pills-add-default-options-tab" tabIndex="0">
                    <Card className='right-content-details'>
                        <Card.Body>
                            <div className='d-flex justify-content-between align-items-center mb-3'>
                                <Card.Title className='mb-0'>Add Default Options</Card.Title>
                                <div className='d-flex'>
                                    <div className="btn-list">
                                        <Button variant="soft-info p-0" onClick={handleEdit}>
                                            <div className='avatar avatar-sm'>
                                                <Icon path={mdiSquareEditOutline} className='avatar-icon' />
                                            </div>
                                        </Button>{' '}
                                        <Button variant="soft-danger p-0">
                                            <div className='avatar avatar-sm'>
                                                <Icon path={mdiTrashCanOutline} className='avatar-icon' />
                                            </div>
                                        </Button>{' '}
                                    </div>

                                </div>
                            </div>
                            <Table responsive className='table-lg border table-nowrap mb-0'>
                                <tbody>
                                    {viewOptionsData.map((data, i) =>
                                        <tr key={i}>
                                            <th>{data.accountheading}</th>
                                            <td>{data.accountsubtext}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </div>
            </div>

            {/* From Modal */}
            <FormModal title="Edit View Options" formModalShow={acOptionEditModalShow} Buttons={acOptionEditButtons} handleFormModalClose={handleAcOptionEditModalClose} rows={acOptionEditRows} handleInputChange={handleAcOptionEditInputChange} handleSubmit={handleAcOptionEditSubmit} />
        </>
    )
}
